import { all_routes } from "../../../router/all_routes";
const routes = all_routes;

export const SidebarData = [
  // ===== Main
  {
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "dashboard",
        icon: "ti ti-layout-dashboard",
        submenu: false,
        showSubRoute: false,
        link: routes.dashboard,
        permissions: [{ action: "read", subject: "Dashboard" }],
      },
    ],
  },

  // ===== Peoples
  {
    label: "peoples",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Peoples",
    submenuItems: [
      {
        label: "students",
        icon: "ti ti-school",
        link: routes.studentList,
        submenu: false,
        showSubRoute: false,
        permissions: [{ action: "getAll", subject: "Student" }],
      },
      {
        label: "my_students",
        icon: "ti ti-school",
        submenu: false,
        showSubRoute: false,
        link: routes.myStudent,
        permissions: [{ action: "read", subject: "Student" }],
      },
      {
        label: "guardians",
        icon: "ti ti-user-shield",
        showSubRoute: false,
        submenu: false,
        link: routes.guardiansList,
        permissions: [{ action: "getAll", subject: "Guardian" }],
      },
      {
        label: "teachers",
        icon: "ti ti-users",
        link: routes.teacherList,
        submenu: false,
        showSubRoute: false,
        permissions: [{ action: "getAll", subject: "Teacher" }],
      },
    ],
  },

  // ===== Academic
  {
    label: "academic",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Academic",
    submenuItems: [
      {
        label: "classes",
        icon: "ti ti-school-bell",
        submenu: false,
        showSubRoute: false,
        link: routes.classes,
        permissions: [{ action: "getAll", subject: "Class" }],
      },
      {
        label: "my_classes",
        icon: "ti ti-school-bell",
        submenu: false,
        showSubRoute: false,
        link: routes.myClasses,
        permissions: [{ action: "read", subject: "Class" }],
      },
      {
        label: "attendance",
        link: routes.attendanceDailySchedule,
        icon: "ti ti-calendar-share",
        showSubRoute: false,
        submenu: false,
        permissions: [{ action: "create", subject: "Absence" }],
      },

      // Staff absences (overview/list/alerts)
      {
        label: "absences",
        icon: "ti ti-calendar-share",
        showSubRoute: true,
        submenu: true,
        submenuItems: [
          {
            label: "absences_overview",
            link: routes.absenceOverview,
            permissions: [{ action: "getAll", subject: "Absence" }],
          },
          {
            label: "absences_list",
            link: routes.absenceList,
            permissions: [{ action: "getAll", subject: "Absence" }],
          },
          {
            label: "student_alerts",
            link: routes.absenceAlerts,
            permissions: [{ action: "getAll", subject: "Absence" }],
          },
        ],
      },

      // “My absences” (for student/guardian)
      {
        label: "my_absences",
        link: routes.absenceStudent,
        icon: "ti ti-calendar-share",
        showSubRoute: false,
        submenu: false,
        permissions: [{ action: "read", subject: "Absence" }],
      },

      // Planner / Routine / Tasks / Messaging
      {
        label: "planning",
        link: routes.planning,
        icon: "ti ti-table",
        showSubRoute: false,
        submenu: false,
        permissions: [{ action: "getAll", subject: "Planner" }],
      },
      {
        label: "my_routine",
        link: routes.studentRoutine,
        icon: "ti ti-table",
        showSubRoute: false,
        submenu: false,
        permissions: [{ action: "read", subject: "Routine" }],
      },
      {
        label: "home_work",
        link: routes.classTask,
        icon: "ti ti-license",
        showSubRoute: false,
        submenu: false,
        permissions: [{ action: "create", subject: "Task" }],
      },
      {
        label: "homework_diary",
        link: routes.myTasks,
        icon: "ti ti-license",
        showSubRoute: false,
        submenu: false,
        permissions: [{ action: "read", subject: "Task" }],
      },
      {
        label: "messaging",
        link: routes.messages,
        icon: "ti ti-message",
        showSubRoute: false,
        submenu: false,
        permissions: [{ action: "read", subject: "Message" }],
      },

      // Examinations
      {
        label: "examinations",
        icon: "ti ti-hexagonal-prism-plus",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "exam_sessions",
            link: routes.examSession,
            permissions: [{ action: "getAll", subject: "ExamSession" }],
          },
          {
            label: "exam_sessions",
            link: routes.teacherExamSession,
            permissions: [{ action: "read", subject: "ExamSession" }],
          },
          {
            label: "mark_matrix.title",
            link: routes.markMatrixTeacher,
            permissions: [{ action: "create", subject: "Mark" }],
          },
          {
            label: "my_marks",
            link: routes.StudentMarks,
            permissions: [{ action: "read", subject: "Mark" }],
          },
          {
            label: "mark_matrix.title",
            link: routes.markMatrix,
            permissions: [{ action: "getAll", subject: "Mark" }],
          },

        ],
      },

      // Student fees & Docs
      {
        label: "my_fees",
        link: routes.myfees,
        icon: "ti ti-report-money",
        submenu: false,
        showSubRoute: false,
        permissions: [{ action: "read", subject: "StudentFee" }],
      },
      {
        label: "document.myDocuments",
        link: routes.myDocuments,
        submenu: false,
        showSubRoute: false,
        icon: "ti ti-file",
        permissions: [{ action: "read", subject: "Document" }],
      },
      {
        icon: "ti ti-user-shield",
        label: "authorizedPickUpPerson.title",
        link: routes.authorizedPickUpPerson,
        permissions: [{ action: "read", subject: "AuthorizedPickUpPerson" }],
      },
      {
        icon: "ti ti-home-move",
        label: "studentExit.title",
        link: routes.studentExit,
        permissions: [{ action: "getAll", subject: "StudentExit" }],
      },
      {
        icon: "ti ti-home-move",
        label: "studentExit.title",
        link: routes.myStudentExit,
        permissions: [{ action: "read", subject: "StudentExit" }],
      },
      {
        icon: "ti ti-notebook",
        label: "teacherJournal.title",
        link: routes.teacherJournal,
        permissions: [{ action: "getAll", subject: "TeacherJournal" }],
      },
      {
        icon: "ti ti-notebook",
        label: "teacherJournal.title",
        link: routes.myTeacherJournal,
        permissions: [{ action: "read", subject: "TeacherJournal" }],
      },

    ],
  },

  // ===== Finance
  {
    label: "finances",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Finance",
    submenuItems: [
      {
        label: "financeDashboard",
        icon: "ti ti-chart-bar",
        submenu: false,
        showSubRoute: false,
        link: routes.financeDashboard,
        permissions: [
          { action: "getAll", subject: "Expense" },
          { action: "getAll", subject: "Fee" },
        ],
      },
      {
        label: "overview",
        icon: "ti ti-eye",
        submenu: false,
        showSubRoute: false,
        link: routes.financeOverview,
        permissions: [
          { action: "getAll", subject: "Expense" },
          { action: "getAll", subject: "Fee" },
        ],
      },
      {
        label: "fees",
        icon: "ti ti-currency-dollar",
        submenu: false,
        showSubRoute: false,
        link: routes.financeFees,
        permissions: [{ action: "getAll", subject: "Fee" }],
      },
      {
        label: "expenses",
        icon: "ti ti-credit-card",
        submenu: false,
        showSubRoute: false,
        link: routes.expenses,
        permissions: [{ action: "getAll", subject: "Expense" }],
      },
      {
        label: "cashbox.title",
        icon: "ti ti-moneybag",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "cashbox.list",
            submenu: false,
            showSubRoute: false,
            link: routes.cashbox.list,
            permissions: [{ action: "getAll", subject: "CashBox" }],
          },
          {
            label: "cashbox.transaction_history",
            submenu: false,
            showSubRoute: false,
            link: routes.cashbox.transactionHistory,
            permissions: [{ action: "getAll", subject: "CashBox" }],
          },
        ]
      },
      {
        label: "cashboxTransactions.title",
        icon: "ti ti-adjustments-dollar",
        submenu: false,
        showSubRoute: false,
        link: routes.cashbox.today,
        permissions: [{ action: "getAll", subject: "Fee" }, { action: "getAll", subject: "Expense" }],
      }
    ],
  },

  // ===== rh
  {
    label: "hrm",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "hrm",
    submenuItems: [
      {
        label: "staff.title",
        icon: "ti ti-users-group",
        submenu: false,
        showSubRoute: false,
        link: routes.staff,
        permissions: [{ action: "getAll", subject: "Staff" }],
      },
      {
        label: "leave.title",
        icon: "ti ti-confetti",
        submenu: false,
        showSubRoute: false,
        link: routes.leave,
        permissions: [{ action: "getAll", subject: "Leave" }],
      },
      {
        label: "leave.my_leaves",
        icon: "ti ti-plane-departure",
        submenu: false,
        showSubRoute: false,
        link: routes.myLeave,
        permissions: [{ action: "read", subject: "Leave" }],
      },
      {
        label: "payroll.title",
        icon: "ti ti-currency-dollar",
        submenu: false,
        showSubRoute: false,
        link: routes.payroll,
        permissions: [{ action: "getAll", subject: "Payroll" }],
      },
      {
        label: "payroll.my_payrolls",
        icon: "ti ti-businessplan",
        submenu: false,
        showSubRoute: false,
        link: routes.myPayroll,
        permissions: [{ action: "read", subject: "Payroll" }],
      },
    ],
  },

  // ===== Settings
  {
    label: "settings",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "settings",
    submenuItems: [
      {
        icon: "ti ti-settings",
        label: "settings",
        link: routes.allSettings,
        permissions: [{ action: "update", subject: "SettingsInstance" }],
      },
      {
        icon: "ti ti-eye",
        label: "audit_logs",
        link: routes.auditLogs,
        permissions: [{ action: "getAll", subject: "AuditLog" }],
      },
      {
        icon: "ti ti-user-plus",
        label: "user_management",
        link: routes.userManagement,
        permissions: [{ action: "update", subject: "UserManagement" }],
      },
    ],
  },

  // ===== Super Admin
  {
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "dashboard",
        icon: "ti ti-layout-dashboard",
        submenu: false,
        showSubRoute: false,
        link: routes.superAdmin.dashboard,
        permissions: [{ action: "isSuperAdmin", subject: "all" }],
      },
      {
        label: "instances",
        icon: "ti ti-building",
        submenu: false,
        showSubRoute: false,
        link: routes.superAdmin.instance,
        permissions: [{ action: "isSuperAdmin", subject: "all" }],
      },
      {
        label: "priceSimulator.title",
        icon: "ti ti-currency-dollar",
        submenu: false,
        showSubRoute: false,
        link: routes.superAdmin.priceSimulator,
        permissions: [{ action: "isSuperAdmin", subject: "all" }],
      },
      {
        label: "users",
        icon: "ti ti-users",
        submenu: false,
        showSubRoute: false,
        link: routes.superAdmin.users,
        permissions: [{ action: "isSuperAdmin", subject: "all" }],
      },

    ],
  },
];
